
/**
 * Weight conversion utilities for kg to lbs and vice versa
 * Conversion factor: 1 kg = 2.20462 lbs
 */

const KG_TO_LBS_FACTOR = 2.20462;

/**
 * Convert kilograms to pounds
 */
export function kgToLbs(kg: number): number {
  return kg * KG_TO_LBS_FACTOR;
}

/**
 * Convert pounds to kilograms
 */
export function lbsToKg(lbs: number): number {
  return lbs / KG_TO_LBS_FACTOR;
}

/**
 * Format weight with appropriate decimal places
 */
export function formatWeight(weight: number, unit: 'kg' | 'lbs' = 'lbs'): string {
  if (unit === 'lbs') {
    return weight.toFixed(1);
  }
  return weight.toFixed(1);
}

/**
 * Round weight to 1 decimal place
 */
export function roundWeight(weight: number): number {
  return Math.round(weight * 10) / 10;
}

/**
 * Validate weight input in lbs
 */
export function validateWeightLbs(weight: number): { isValid: boolean; message?: string } {
  if (weight < 50) {
    return { isValid: false, message: 'Weight must be at least 50 lbs' };
  }
  if (weight > 1000) {
    return { isValid: false, message: 'Weight must be less than 1000 lbs' };
  }
  return { isValid: true };
}

/**
 * Validate body fat percentage
 */
export function validateBodyFatPercentage(percentage: number): { isValid: boolean; message?: string } {
  if (percentage < 1) {
    return { isValid: false, message: 'Body fat percentage must be at least 1%' };
  }
  if (percentage > 100) {
    return { isValid: false, message: 'Body fat percentage must be 100% or less' };
  }
  return { isValid: true };
}

/**
 * Validate muscle mass in lbs
 */
export function validateMuscleMassLbs(mass: number): { isValid: boolean; message?: string } {
  if (mass < 20) {
    return { isValid: false, message: 'Muscle mass must be at least 20 lbs' };
  }
  if (mass > 300) {
    return { isValid: false, message: 'Muscle mass must be less than 300 lbs' };
  }
  return { isValid: true };
}
